import { Grid } from "@mui/material";
import React from "react";
import {
  MainStyledTypography,
  StyledTypography,
  ItemGrid,
} from "./SubHeaderStyled.js";
import {useTheme} from "@mui/material/styles";
import { getSubHeaderBannerBackground } from "./subHeaderBannerStyles";

const SubHeader = ({ forceLight = false, title }) => {
  const theme = useTheme();
  const mainTextStyle = forceLight ? { color: "#4A2CF5" } : undefined;
  const secondaryTextStyle = forceLight ? { color: "#000000" } : undefined;

  return (
    <>
      <Grid
        container
        position={"relative"}
        alignItems="center"
        sx={{
          background: forceLight ? "#F6F4FF" : getSubHeaderBannerBackground(theme),
          minHeight: 94,
        }}
      >
        <ItemGrid>
          <Grid
            container
            flexDirection={"column"}
            justifyContent="center"
            style={{ padding: "19px 120px 19px 48px" }}
          >
            {title ? (
              <Grid item>
                <MainStyledTypography style={mainTextStyle}>
                  {title}
                </MainStyledTypography>
              </Grid>
            ) : (
              <>
                <Grid item>
                  <MainStyledTypography style={mainTextStyle}>
                    Find what you're looking for with
                  </MainStyledTypography>
                </Grid>
                <Grid item>
                  <StyledTypography style={secondaryTextStyle}>AlphaSearch.</StyledTypography>
                </Grid>
              </>
            )}
          </Grid>
        </ItemGrid>
      </Grid>
    </>
  );
};

export default SubHeader;
